import { ReusablePaymentMethodBase } from './reusable-payment-method-base';

export interface Paypal extends ReusablePaymentMethodBase {
  type: 'PAY_PAL';
  emailAddress: string;
}
